module.exports = __webpack_public_path__ + "static/media/icon-xiaoitishi.87eace60.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon-xiaoitishi.png
// module id = 197
// module chunks = 0